import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { isSocialDisable } from '../config';
import { HashLink } from 'react-router-hash-link';

const Footer: React.FC = () => {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowBackToTop(true);
      } else {
        setShowBackToTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const col1Size = isSocialDisable ? 5 : 4;
  const col2Size = isSocialDisable ? 3 : 2;
  const col3Size = isSocialDisable ? 4 : 3;

  return (
    <>
      <footer className="bg-dark text-white pt-5 pb-4">
        <Container>
          <Row>
            <Col md={col1Size} className="mb-4">
              <h5 className="fw-bold">Göktaş Mekanik ve Doğalgaz</h5>
              <p className="text-white">
                1998 yılından bu yana güvenilir ve yenilikçi tesisat çözümleri.
              </p>
            </Col>
            <Col md={col3Size} className="mb-4">
              <h5 className="fw-bold">İletişim</h5>
              <p className="text-white mb-2">
                <i className="fas fa-map-marker-alt me-2"></i>
                Oruçreis Mahallesi 562. Sokak No: 22/b Esenler/İstanbul
              </p>
              <p className="text-white mb-2">
                <i className="fas fa-phone-alt me-2"></i>
                <a href="tel:+905327907812" className="text-decoration-none text-white">+90 532 790 78 12</a>
              </p>
              <p className="text-white">
                <i className="fas fa-envelope me-2"></i>
                <a href="mailto:goktastesisat@gmail.com" className="text-decoration-none text-white">goktastesisat@gmail.com</a>
              </p>
            </Col>
            {!isSocialDisable && (
              <Col md={3} className="mb-4">
                <h5 className="fw-bold">Sosyal Medya</h5>
                <p className="text-white">Bizi sosyal medyada takip edin.</p>
                <div>
                  <a href="#" className="text-white me-3" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
                  <a href="#" className="text-white me-3" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
                  <a href="#" className="text-white me-3" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
                  <a href="#" className="text-white" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
                </div>
              </Col>
            )}
          </Row>
          <hr />
          <Row className="text-center">
            <Col>
              <p className="text-white">&copy; {new Date().getFullYear()} Göktaş Mekanik ve Doğalgaz. Tüm Hakları Saklıdır.</p>
            </Col>
          </Row>
        </Container>
      </footer>
      {showBackToTop && (
        <Button
          variant="primary"
          onClick={scrollToTop}
          className="back-to-top-btn"
          aria-label="Go to top"
        >
          <i className="fas fa-arrow-up"></i>
        </Button>
      )}
    </>
  );
};

export default Footer;